<template>
  <div class="bg-white shadow-sm p-3 rounded">
    <p class="h5 mb-1">{{ title }}</p>
    <p class="text-muted text-sm mb-2">{{ truncatedDescription }}</p>
    <div class="d-flex">
      <p class="text-dark mb-0 font-weight-bold">{{ price }}</p>
      <p v-if="duration" class="text-muted mb-0 ml-2 d-flex align-items-center">
        <Clock class="svg-24 text-muted mr-1" /> {{ duration }}
      </p>
    </div>
    <div class="mt-2">
      <ActionButton :href="link">{{ linkText }}</ActionButton>
    </div>
  </div>
</template>

<script>
import Clock from "../../../icons/atalanda/clock-16.svg";
import ActionButton from "../buttons/ActionButton.vue";

export default {
  components: {
    Clock,
    ActionButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      required: true,
    },
  },
  computed: {
    truncatedDescription() {
      return this.description.length >= 150
        ? this.description.substring(0, 150) + "..."
        : this.description;
    },
  },
};
</script>
